import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import CampaignPage from 'Containers/Campaigns/Page'
import StatsDashboard from 'Containers/StatsDashboard'

class Dashboard extends React.Component {
  render() {
    const { match, location } = this.props
    const { campaignId } = match.params
    var path = location.pathname.slice(match.url.length)
    return (
      <CampaignPage
        active={this.props.nav}
        history={this.props.history}
        match={this.props.match}
        campaignId={campaignId}
      >
        <StatsDashboard
          basePath={this.props.match.url}
          campaignId={campaignId}
          path={path}
        />
      </CampaignPage>
    )
  }
}

Dashboard.propTypes = {
  match: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  cities: state.city.citiesList,
  user: state.auth.user,
})

export default connect(
  mapStateToProps,
  {},
)(Dashboard)



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/Dashboard/index.js